//import Libraries
import React, { Component } from 'react';
import PropTypes from 'prop-types';

//import Components
import {Button, Row, Col} from 'reactstrap'

//import Styles

const upDownButton = ({ onOrderUp, onOrderDown, upLabel, downLabel, disabled }) => {
    return ( 
        <div>
            <Button
                onClick={onOrderUp}
                disabled={disabled}
                size="sm"
            >
                {upLabel}
            </Button>
            <Button
                onClick={onOrderDown}
                disabled={disabled}
                size="sm"
            >
                {downLabel}
            </Button>
        </div>
    );
}

export default upDownButton;

upDownButton.propTypes = {
    onOrderUp : PropTypes.func.isRequired,
    onOrderDown : PropTypes.func.isRequired,
    upLabel : PropTypes.string,
    downLabel : PropTypes.string,
}

upDownButton.defaultProps = {
    upLabel : 'Up',
    downLabel : 'Down'
}


// WEBPACK FOOTER //
// ./src/pages/Admin/Components/UpDownButton/UpDownButton.js